import React from 'react';
import { Navigate } from 'react-router-dom';
import { message } from 'antd';
import { hasAdminAccess, hasPermission } from '../../utils/permissions';

/**
 * ProtectedRoute — yêu cầu đăng nhập + có quyền admin hoặc staff.
 * Truyền prop `permission="view_statistics"` để kiểm tra permission cụ thể.
 */
const ProtectedRoute = ({ children, permission }) => {
    const isAuthenticated = !!localStorage.getItem('token');

    if (!isAuthenticated) {
        message.error('Vui lòng đăng nhập để tiếp tục!');
        return <Navigate to="/login" replace />;
    }

    if (!hasAdminAccess()) {
        message.error('Bạn không có quyền truy cập trang này!');
        return <Navigate to="/" replace />;
    }

    if (permission && !hasPermission(permission)) {
        message.error('Bạn không có quyền truy cập tính năng này!');
        return <Navigate to="/admin" replace />;
    }

    return children;
};

export default ProtectedRoute; 